import {
  Routes,
  Route,
  Navigate,
  useParams,
  useNavigate,
} from "react-router-dom";
import Home from "./pages/Home";
// import Signup from "./pages/signup";
// import Login from "./pages/login";
import ForgotPassword from "./pages/forget";
import DefaultLayout from "./layouts/default";
import ProtectedRoute from "./components/protectedRoute";
import { useDispatch, useSelector } from "react-redux";
import DashboardLayout from "./layouts/dashboard";
import Games from "./pages/dashboard/games";
import ProfilePage from "./pages/dashboard/profile";
import History from "./pages/dashboard/history";
import Payment from "./pages/dashboard/payment";
import Cashout from "./pages/dashboard/cashout";
import ActiveLinkSlice from "./pages/dashboard/activelinkslice";
import { useEffect } from "react";
import { GetUserBlance } from "./redux/slices/userbal";
import Wallet from "./pages/dashboard/wallet";
import { logout } from "./redux/slices/auth";
import { ThemeProvider } from "@mui/material";
import { ablyClient } from "./lib/socket";
// import TEst from "./pages/testing";
import TrackPageViews from "./TrackPageViews";
import PrivacyPolicy from "./pages/privacypolicy";
import theme from "./lib/theme";
import { GetPaymentMethods } from "./redux/slices/paymentmethod";
import TermsAndConditions from "./pages/termsconditions";
import DepositGift from "./components/modal/depositgift";
import SignupGift from "./components/modal/signupgift";
import SpinWheelPage from "./pages/dashboard/spinawheel";
import { GetAvailableGifts } from "./redux/slices/gift";
import { LoadUserInterface } from "./redux/slices/interface";
import FabSection from "./components/fabsection/index";
import {
  listenForForegroundMessages,
  registerAndSaveFcmToken,
} from "./lib/fcm";

const SESSION_TIMEOUT = 30 * 60 * 1000;

function App() {
  const channel = ablyClient.channels.get("general-chat");
  const isthat = useSelector((tate) => tate.login.isAuthenticated);
  const sessions = useSelector((va) => va?.usercreate);
  const navigates = useNavigate();
  const isAuthenticated = !!isthat;
  const dispatch = useDispatch();
  const data = useSelector((tate) => tate.login.user);
  const routeParams = useParams();
  useEffect(() => {
    if (isAuthenticated) {
      dispatch(GetUserBlance(data));
      dispatch(GetAvailableGifts());
    }
  }, [routeParams]);

  useEffect(() => {
    if (isAuthenticated) {
      dispatch(GetPaymentMethods());
    }
  }, [dispatch, isAuthenticated]);

  // Register / refresh FCM token whenever customer is logged in
  useEffect(() => {
    if (!isAuthenticated || !data?.email) return;

    registerAndSaveFcmToken(data.email);
    listenForForegroundMessages();
  }, [isAuthenticated, data?.email]);

  useEffect(() => {
    dispatch(LoadUserInterface());
    const updateActivity = () => {
      sessionStorage.setItem("lastActivity", Date.now().toString());
    };

    const checkTimeout = () => {
      const lastActivity = parseInt(sessionStorage.getItem("lastActivity"), 10);
      if (!isNaN(lastActivity)) {
        const currentTime = Date.now();
        if (currentTime - lastActivity > SESSION_TIMEOUT) {
          sessionStorage.clear();
          const dd = {
            loading: false,
            error: null,
            isAuthenticated: false,
            user: null,
            token: null,
          };
          localStorage.removeItem("logged");
          if (channel?.state === "joined") {
            channel.presence.leave();
          }
          dispatch(logout(dd));
          // navigates("/login");
        }
      }
    };

    updateActivity();

    const events = ["mousemove", "keydown", "click"];
    events.forEach((event) => window.addEventListener(event, updateActivity));

    const interval = setInterval(checkTimeout, 60000); // check every 1 minute

    return () => {
      events.forEach((event) =>
        window.removeEventListener(event, updateActivity)
      );
      clearInterval(interval);
    };
  }, []);

  return (
    <ThemeProvider theme={theme}>
      {sessions?.loading && (
        <div className="rounded-md fixed h-screen w-full bg-white/30 flex justify-center items-center z-[99999]">
          <svg
            aria-hidden="true"
            className="w-20 h-20 text-gray-300 animate-spin dark:text-gray-600 fill-[#e4008b]"
            viewBox="0 0 100 101"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
              fill="currentColor"
            />
            <path
              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
              fill="currentFill"
            />
          </svg>
          <span className="sr-only">Loading...</span>
        </div>
      )}
      <TrackPageViews />
      <Routes>
        <Route element={<DefaultLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/forgot" element={<ForgotPassword />} />
          {/* <Route
            path="/login"
            element={isAuthenticated ? <Navigate to="/dashboard" /> : <Login />}
          /> */}
          {/* <Route path="/test" element={<TEst />} /> */}
          {/* <Route
            path="/signup"
            element={
              isAuthenticated ? <Navigate to="/dashboard" /> : <Signup />
            } */}
          {/* /> */}
          <Route path="/terms&conditions" element={<TermsAndConditions />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        </Route>
        <Route
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <SignupGift />
              <DepositGift />
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          <Route path="/dashboard" element={<Games />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/history" element={<History />} />
          <Route path="/wallet" element={<Wallet />} />
          <Route path="/Payment" element={<Payment />} />
          <Route path="/cashout" element={<Cashout />} />
          <Route path="/spin-a-wheel" element={<SpinWheelPage />} />
          <Route path="/activelinkslice" element={<ActiveLinkSlice />} />
        </Route>
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
      <FabSection />
    </ThemeProvider>
  );
}

export default App;
